<template>
    <span class="d-flex flex-column">
        <span class="w-100 text-center p-0 m-0">
            <b-icon icon="x" variant="success" v-if="isNotAggressive()" scale="2" />
            <b-icon icon="check" variant="danger" v-else-if="isAggressive()" scale="2"/>
            <b-icon icon="question" variant="secondary" v-else-if="needsRepeat()" scale="2"/>
            <span v-else>&mdash;</span>
        </span>
        <slot name="secondary">
        </slot>
    </span>
</template>

<script>
export default {
    name: "AnimalAggressiveCell",
    props: {
        value: {}
    },
    methods: {
        isNotAggressive() {
            return this.value === 1
        },
        isAggressive() {
            return this.value === 2
        },
        needsRepeat() {
            return this.value === 3
        }
    }
}
</script>

<style scoped>

</style>